import { EventAlignmentPicker } from './EventAlignmentPicker';
import { EventIconPicker } from './EventIconPicker';
import { EventThemePicker } from './EventThemePicker';
import { FIELD_LABEL_CLASS, type SectionProps } from './eventFormShared';

/** Theme, icon and alignment only - `actionLabel`/`countdownToEvent` moved to
 *  Content with the rest of the meeting's authored copy, so this section is
 *  purely "how the banner/pop-up look", not "what they say". */
export function AppearanceSection({ draft, set, errors, touched, canManage }: SectionProps) {
    return (
        <div className="grid grid-cols-1 gap-4">
            <div>
                <label htmlFor="event-theme-preset" className={FIELD_LABEL_CLASS}>
                    Theme preset *
                </label>
                <EventThemePicker
                    id="event-theme-preset"
                    value={draft.themePreset}
                    onChange={(v) => set('themePreset', v)}
                    disabled={!canManage}
                />
                {touched && errors.themePreset && (
                    <p className="text-red-500 text-xs mt-1">{errors.themePreset}</p>
                )}
            </div>
            <div>
                <label htmlFor="event-icon" className={FIELD_LABEL_CLASS}>
                    Icon (optional)
                </label>
                <EventIconPicker
                    id="event-icon"
                    value={draft.iconKey}
                    onChange={(v) => set('iconKey', v)}
                    disabled={!canManage}
                />
            </div>
            <div>
                <label htmlFor="event-alignment" className={FIELD_LABEL_CLASS}>
                    Alignment
                </label>
                <EventAlignmentPicker
                    id="event-alignment"
                    value={draft.alignment}
                    onChange={(v) => set('alignment', v)}
                    disabled={!canManage}
                />
                <p className="text-[11px] text-gray-400 mt-1">
                    Left and centered banners can both show an icon - it's the alignment that
                    changes the layout, not the icon.
                </p>
            </div>
        </div>
    );
}
